<div id="grid-wrapper" style="width: 100%; height: 100%">
  <ag-grid-angular
    [domLayout]="'normal'"
    [style.height]="supplierExceptionsOverviewData.length > 20 ? '750px' : 'none'"
    [gridOptions]="gridOptions"
    [rowData]="rowData"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [pagination]="false"
    [multiSortKey]="multiSortKey"
    [getContextMenuItems]="getContextMenuItems"
    [tooltipShowDelay]="tooltipShowDelay"
    [enableBrowserTooltips]="true"
    [components]="frameworkComponents"
    [excelStyles]="excelStyles"
    (gridReady)="onGridReady($event)"
    (firstDataRendered)="onFirstDataRendered($event)"
    (gridSizeChanged)="onGridSizeChanged($event)"
    class="ag-theme-alpine_customize"></ag-grid-angular>
</div>

<pas-sidebar-holder [hasNavbar]="true">
  <div class="sidebar-contents">
    <ng-container>
      <div class="sidebar-element sidebar-row">
        <ul class="navbar-nav">
          <ng-container>
            @if (userHasSuppliersAndRatesRight()) {
              <li [ngClass]="'nav-item'">
                <a (click)="onNewSupplierExceptionBtn()" class="nav-link link-sidebar">
                  <i class="material-icons">add_circle_outline</i>
                  <span class="hidden-md-down" ui-test-id="newSupplierExceptionBtn">
                    {{ 'SUPPLIER_EXCEPTIONS_DIALOG_NEW_BUTTON' | translate }}
                  </span>
                </a>
              </li>
            }
          </ng-container>
          <li [ngClass]="isCreateExcelSupplierExceptionsEnabled ? 'nav-item' : 'nav-item disabled'">
            <a (click)="onBtnCreateExcelSupplierExceptions()" class="nav-link link-sidebar">
              <i class="material-icons">get_app</i>
              <span class="hidden-md-down" ui-test-id="excelExportBtn">
                {{ 'EXCEL_EXPORT' | translate }}
              </span>
            </a>
          </li>
        </ul>
      </div>
    </ng-container>
  </div>
</pas-sidebar-holder>

<ng-template #SupplierExceptionDialogTemplate>
  <tur-generic-modal-content
    [acceptanceAllowed]="isAcceptanceAllowed()"
    (confirm)="onAcceptSupplierExceptionDialog()"
    (cancel)="onCloseSupplierExceptionDialog()"
    id="SupplierExceptionDialog"
    modalTitle="{{ 'SUPPLIER_EXCEPTIONS_DIALOG_TITLE' | translate }}"
    acceptButtonLbl="{{ 'SAVE' | translate }}"
    cancelButtonLbl="{{ 'CANCEL' | translate }}"
    confirmationMessage="">
    <div [formGroup]="supplierExceptionDialogForm">
      <div class="col-12">
        <div class="row">
          <pas-input-number
            [hasClearBtn]="false"
            [maxLength]="6"
            [formControl]="$any(supplierExceptionDialogForm.get('supplierId'))"
            [validationMessages]="validationMessages$ | async"
            class="col-6 pull-right"
            id="supplierId"
            required="true"
            subLabel="{{ 'SUPPLIER_EXCEPTIONS_DIALOG_SUPPLIER_NUMBER' | translate }}"></pas-input-number>
          <pas-input
            [maxLength]="250"
            [formControl]="$any(supplierExceptionDialogForm.get('supplierName'))"
            class="col-6"
            id="supplierName"
            subLabel="{{ 'SUPPLIER_EXCEPTIONS_TABLE_SUPPLIER' | translate }}"></pas-input>
        </div>
        <br />
        <div class="row">
          <pas-datetime-picker
            [formControl]="$any(supplierExceptionDialogForm.get('exclusionFrom'))"
            [validationMessages]="validationMessages$ | async"
            class="col-6"
            id="exclusionFrom"
            pickerType="date"
            required="true"
            locale="de"
            subLabel="{{ 'SUPPLIER_EXCEPTIONS_DIALOG_EXCLUSION_FROM' | translate }}"
            confirmButtonText="{{ 'CONFIRM' | translate }}"></pas-datetime-picker>
          <pas-datetime-picker
            [formControl]="$any(supplierExceptionDialogForm.get('exclusionTill'))"
            [validationMessages]="validationMessages$ | async"
            class="col-6"
            id="exclusionTill"
            pickerType="date"
            locale="de"
            subLabel="{{ 'SUPPLIER_EXCEPTIONS_DIALOG_EXCLUSION_TILL' | translate }}"
            confirmButtonText="{{ 'CONFIRM' | translate }}"></pas-datetime-picker>
        </div>
        <br />
        <div class="col-12" style="padding-left: 10px; padding-right: 10px">
          <pas-textarea
            [formControl]="$any(supplierExceptionDialogForm.get('reason'))"
            [cols]="50"
            [maxLength]="3000"
            required="true"
            subLabel="{{ 'SUPPLIER_EXCEPTIONS_DIALOG_EXCLUSION_REASON' | translate }}"></pas-textarea>
        </div>
      </div>

      <div class="col-12">
        <div class="row" style="padding: 0px 315px">
          <div class="d-flex justify-content-center align-items-center">
            @if (spinnerActive) {
              <pas-spinner [size]="'small'"></pas-spinner>
            }
          </div>
        </div>
      </div>
    </div>
  </tur-generic-modal-content>
</ng-template>
